<template>
  <div>
    <div ref="thresholdElement" class="b-products-table">
      <div v-if="headers" ref="stickyElement" class="b-products-table__head">
        <div
          v-for="(header, index) in headers"
          :key="index"
          class="b-products-table__td">
          {{ header }}
          <br v-if="index === 'unitPriceTitle'" />
          <span v-if="index === 'unitPriceTitle'">
            {{ lastUpdated }}
          </span>
        </div>
      </div>
      <div class="b-products-table__body">
        <div
          v-for="record in records"
          :key="record.id"
          class="b-products-table__row"
          :class="{ 'b-products-table__row--featured': record.isFeatured }"
          @click="redirect(record.isFeatured, record.url)"
          @mouseover="lottiePlay(record)"
          @mouseleave="lottieStop(record)">
          <template v-if="!record.isFeatured">
            <div class="b-products-table__td">
              <i class="icon-arrow-right"></i>
              <span>{{ record.name }}</span>
            </div>
            <span class="b-products-table__td">
              {{ record.shareClass }}
            </span>
            <span class="b-products-table__td">{{ record.type }}</span>
            <span class="b-products-table__td">
              <img :src="record.risk" />
            </span>
            <span class="b-products-table__td b-products-table__price">
              {{ record.unitPrice }}
            </span>
            <a
              :href="record.factsheetUrl"
              download
              class="b-products-table__td">
              <div class="e-download">
                <Vue3Lottie
                  :ref="`lottiePlayer-${record.id}`"
                  animation-link="./../../../imgs/lotties/downloadFile.json"
                  :auto-play="false"
                  :height="24"
                  :width="24" />
              </div>
            </a>
          </template>

          <template v-else>
            <div class="content">
              <div class="title">{{ record.bannerData.title }}</div>
              <div class="description">
                {{ record.bannerData.description }}
              </div>
              <p class="text" v-html="record.bannerData.text"></p>
            </div>
            <div class="right-side">
              <a :href="record.url" class="btn btn-outline-white">
                <span>{{ record.bannerData.urlTitle }}</span>
              </a>
            </div>
            <img
              v-if="record.bannerData.bgImg"
              :src="record.bannerData.bgImg"
              alt="" />
          </template>
        </div>
      </div>
    </div>

    <div class="b-products-table--mob">
      <template v-if="records">
        <div
          v-for="record in records"
          :key="record"
          class="b-products-table__row"
          :class="{ 'b-products-table__row--featured': record.isFeatured }"
          @click="redirect(record.isFeatured, record.url)">
          <template v-if="!record.isFeatured">
            <span>{{ record.name }}</span>
            <div class="b-products-table__td">
              <span>{{ Object.values(headers)[1] }}</span>
              <span>{{ record.shareClass }}</span>
            </div>
            <div class="b-products-table__td">
              <span>{{ Object.values(headers)[2] }}</span>
              <span>{{ record.type }}</span>
            </div>
            <div class="b-products-table__td">
              <span>{{ Object.values(headers)[3] }}</span>
              <img :src="record.risk" alt="" />
            </div>
            <div class="b-products-table__td">
              <span>{{ Object.values(headers)[4] }}</span>
              <span>{{ record.unitPrice }}</span>
            </div>
            <div class="b-products-table__td" @click.stop>
              <span>{{ Object.values(headers)[5] }}</span>
              <a :href="record.factsheetUrl" download>
                <span class="e-download--label">Λήψη</span>
                <div class="e-download">
                  <Vue3Lottie
                    :ref="`lottiePlayer-${record.id}`"
                    animation-link="./../../../imgs/lotties/downloadFile.json"
                    :auto-play="false"
                    :height="24"
                    :width="24" />
                </div>
              </a>
            </div>
          </template>
          <template v-else>
            <div class="content">
              <div class="title">{{ record.bannerData.title }}</div>
              <div class="description">
                {{ record.bannerData.description }}
              </div>
              <p class="text" v-html="record.bannerData.text"></p>
              <a :href="record.url" class="btn btn-outline-white">
                <span>{{ record.bannerData.urlTitle }}</span>
              </a>
            </div>
            <img
              v-if="record.bannerData.bgImg"
              :src="record.bannerData.bgImg"
              alt="" />
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import { Vue3Lottie } from 'vue3-lottie'
import StickyHeader from './../../modules/w-sticky-header'

export default {
  components: {
    Vue3Lottie,
  },
  props: {
    records: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      headers: null,
      lastUpdated: '',
      links: null,
    }
  },
  mounted() {
    const { links } = lib.getData('breadcrumbData')
    const { headers, lastUpdated } = lib.getData('productsData')
    this.links = links
    this.headers = headers
    this.lastUpdated = lastUpdated

    this.$nextTick(() => {
      this.stickyHeader = new StickyHeader(
        this.$refs.stickyElement,
        this.$refs.thresholdElement
      )
    })
  },
  methods: {
    lottiePlay(record) {
      if (record.isFeatured) return
      const lottie = this.$refs[`lottiePlayer-${record.id}`][0]
      lottie.play()
    },
    lottieStop(record) {
      if (record.isFeatured) return
      const lottie = this.$refs[`lottiePlayer-${record.id}`][0]
      lottie.goToAndStop(0)
    },
    redirect(isFeatured, url) {
      if (isFeatured) return
      location.href = url
    },
  },
}
</script>
